import { FC, useState } from "react";
import { Tab } from "@headlessui/react";
import classNames from "classnames";
import { IOurPriceDataType } from "src/lib/constants/table-type";
import OurPricesTable from "./our-prices-table";
import { useMutation } from "react-query";
import client from "../../api";
import { APISomethingWrongMsg, NetworkDisconnectMsg, permissions as permissionConstants } from "src/lib/constants";
import { getErrorMessage, logger } from "src/lib/utils";
import { IGetOurPricesInput } from "src/api/types";
import usePermissions from "src/hooks/use-permissions";

interface IBusinessTabs {
  lang: string;
  dataSource: IOurPriceDataType[];
  setDataSource: React.Dispatch<React.SetStateAction<IOurPriceDataType[]>>;
  isLoading: boolean;
  isWithdrawal?: boolean;
  isKwickpay?: boolean;
  isCard?: boolean;
  setIsAlertOpened?: any;
  setAlertText?: any;
}

const tabLists = ["Private", "Business"];

const BusinessTabs: FC<IBusinessTabs> = ({
  lang,
  isWithdrawal,
  isKwickpay,
  isCard,
  isLoading,
  dataSource,
  setDataSource,
  setIsAlertOpened,
  setAlertText,
}) => {
  const { canAdd } = usePermissions(permissionConstants.OUR_PRICES);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [editingKey, setEditingKey] = useState("");

  logger.log(editingKey, "EDITING KEY");

  const filteredCardTypeExists = () => {
    return dataSource.some(
      (item) => item.type === "card" && item.user_type === "vibe",
    );
  };

  const addRow = () => {
    const newRow: any = {
      key: Date.now().toString(),
      destination: "",
      fee: "",
      lang: lang,
      limit: "",
      period: "",
      type: isCard
        ? "card"
        : isWithdrawal
          ? "withdrawal"
          : isKwickpay
            ? "kwikpay"
            : "deposit",

      user_type: isCard
        ? filteredCardTypeExists()
          ? "vibe"
          : "aura"
        : selectedTabIndex === 0
          ? "private"
          : "business",
      isNew: true,
    };
    setDataSource((prev) => [...prev, newRow]);
    setEditingKey(newRow.key);
  };

  const makeTabList = () => {
    const tabListsUI = tabLists.map((item, index) => (
      <Tab
        key={`tab_list_${index}`}
        className={({ selected }) =>
          classNames(
            "relative pb-1.5 before:absolute before:left-0 before:bottom-0 before:h-0.5 before:bg-primary before:transition-all before:duration-300 before:ease-in-out hover:text-primary",
            "ring-transparent ring-opacity-60 ring-offset-0 ring-offset-transparent focus:outline-none focus:ring-0",
            {
              "font-semibold text-primary before:w-full": selected,
              "text-secondary before:w-0 dark:text-light-800": !selected,
            },
          )
        }
      >
        <p className="text-[14px] sm:text-[16px]">{item}</p>
      </Tab>
    ));
    return (
      <Tab.List className="px-2 sm:px-8 mt-2 sm:mt-4 font-manrope font-medium relative space-x-4 sm:space-x-8 z-10 flex items-center">
        {tabListsUI}
      </Tab.List>
    );
  };

  return (
    <div className="flex flex-col w-full bg-white rounded-[12px] p-4">
      <Tab.Group
        selectedIndex={selectedTabIndex}
        onChange={(tabIdx: number) => setSelectedTabIndex(tabIdx)}
      >
        {!isCard && makeTabList()}{" "}
        <Tab.Panels>
          {canAdd && (
            <div className="table-footer table-footer--inside">
              <button
                className="button button--height-30 button--auto-width button--type4"
                type="button"
                onClick={addRow}
                disabled={editingKey !== "" ? true : false}
              >
                <span className="btn-icon btn-icon--max-width">+</span>
                Add more
              </button>
            </div>
          )}
          <Tab.Panel className="border-0 focus:border-0 focus:ring-0 ring-0">
            <OurPricesTable
              lang={lang}
              isWithdrawal={isWithdrawal}
              isKwickpay={isKwickpay}
              dataSource={dataSource}
              setDataSource={setDataSource}
              isLoading={isLoading}
              editingKey={editingKey}
              setEditingKey={setEditingKey}
              isCard={isCard}
            />
          </Tab.Panel>
          <Tab.Panel className="border-0 focus:border-0 focus:ring-0 ring-0">
            <OurPricesTable
              lang={lang}
              isWithdrawal={isWithdrawal}
              isKwickpay={isKwickpay}
              dataSource={dataSource}
              setDataSource={setDataSource}
              isLoading={isLoading}
              editingKey={editingKey}
              setEditingKey={setEditingKey}
              isBusiness
              isCard={isCard}
            />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default BusinessTabs;
